import axios from 'axios'

/**
 * Marca de "a sessão expirou no meio do uso". Gravada quando uma requisição autenticada volta 401;
 * a tela de login consome a marca para avisar o usuário de por que foi deslogado.
 */
const SESSAO_EXPIRADA_STORAGE_KEY = 'kt-auth-sessao-expirada'

// Janela em que um 401 sem envelope é considerado parte do encerramento já em curso: as várias
// requisições que falham juntas não abrem, cada uma, um alerta por cima da tela de login.
const JANELA_ENCERRAMENTO_MS = 10_000

// Endpoints de autenticação respondem 401 por credencial inválida, não por sessão vencida.
const ROTAS_AUTENTICACAO = ['/auth/', '/token']

export const marcarSessaoExpirada = () => {
  try {
    sessionStorage.setItem(SESSAO_EXPIRADA_STORAGE_KEY, Date.now().toString())
  } catch {
    // Sem storage o aviso some, mas o redirecionamento para o login continua.
  }
}

/** Lê e apaga a marca: o aviso aparece uma vez só. */
export const consumirSessaoExpirada = (): boolean => {
  try {
    const marcada = sessionStorage.getItem(SESSAO_EXPIRADA_STORAGE_KEY) !== null
    sessionStorage.removeItem(SESSAO_EXPIRADA_STORAGE_KEY)
    return marcada
  } catch {
    return false
  }
}

export const sessaoEncerrandoPorExpiracao = (): boolean => {
  try {
    const marcadaEm = Number(sessionStorage.getItem(SESSAO_EXPIRADA_STORAGE_KEY))
    return marcadaEm > 0 && Date.now() - marcadaEm < JANELA_ENCERRAMENTO_MS
  } catch {
    return false
  }
}

/** 401 de uma requisição autenticada comum (token vencido ou revogado). */
export const ehSessaoExpirada = (error: unknown): boolean => {
  if (!axios.isAxiosError(error) || error.response?.status !== 401) return false
  const url = error.config?.url ?? ''
  return !ROTAS_AUTENTICACAO.some((rota) => url.includes(rota))
}
